import { Button } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { SalesDashboardQueries } from '@sales-app/graphql/queries/salesDashboard.queries'
import React, { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { useUserContext } from '@/context'
import { useGraphql } from '@/hooks/useGraphql'
import LoadingSkeleton from '@/views/Dashboard/LoadingSkeleton'

import { AgentDashboard } from '../AgentDashboard/AgentDashboard'
import { DashboardStats } from './DashboardStats'
import { PotentialBookingSummary } from './PotentialBookingSummary'

export const ManagerDashboard = () => {
  const [isSupervisorView, setIsSupervisorView] = useState(true)
  const { user } = useUserContext()
  const navigate = useNavigate()

  const {
    data: supervisorDashboardData,
    isLoading,
    isRefetching,
  } = useGraphql<SalesDashboardQueries.GET_SUPERVISOR_DASHBOARD.Response>(
    SalesDashboardQueries.getSupervisorDashboard.name,
    SalesDashboardQueries.getSupervisorDashboard(),
    { filter: { supervisorId: user?.agent?.id } },
    { refetchOnMount: 'always' },
  )

  const { statData, potentialBookingSummaryData } = useMemo(() => {
    return {
      statData: supervisorDashboardData?.supervisorDashboard?.dashboardStats,
      potentialBookingSummaryData: supervisorDashboardData?.supervisorDashboard?.potentialBookingsSummary,
    }
  }, [
    supervisorDashboardData?.supervisorDashboard?.dashboardStats,
    supervisorDashboardData?.supervisorDashboard?.potentialBookingsSummary,
  ])

  function handleOnChange() {
    setIsSupervisorView(!isSupervisorView)
  }

  return (
    <>
      {isLoading || isRefetching ? (
        <LoadingSkeleton />
      ) : (
        <>
          <div className="mb-4 flex w-full flex-row items-center gap-2 md:mr-4 md:justify-end md:gap-3 lg:flex-wrap">
            <StyledLabel checked={isSupervisorView} htmlFor="checkbox">
              <input checked={isSupervisorView} id="checkbox" onChange={handleOnChange} type="checkbox" />
              <span className="">Supervisor View</span>
              <span>Agent View</span>
            </StyledLabel>
            <Button
              className="mx-2 bg-action-primary"
              onClick={() => {
                navigate('/agents')
              }}
              size="small"
            >
              View Agents
            </Button>
          </div>
          {isSupervisorView ? (
            <>
              <div>
                <DashboardStats data={statData} />
              </div>
              <div className="mt-4 grid grid-cols-8 gap-4">
                <div className="col-span-8">
                  <h3 className="text-header-sm">Summary</h3>
                  <PotentialBookingSummary data={potentialBookingSummaryData} />
                </div>
              </div>
            </>
          ) : (
            <div>
              <AgentDashboard />
            </div>
          )}
        </>
      )}
    </>
  )
}

const StyledLabel = styled.label<{ checked: boolean }>`
  background-color: #f3f3f2;
  cursor: pointer;
  height: 3rem;
  display: flex;
  position: relative;
  border-radius: 100px;

  input {
    opacity: 0;
    width: 0;
  }
  span {
    display: flex;
    font-weight: 500;
    z-index: 1;
    width: 10rem;
    align-items: center;
    justify-content: center;
  }

  &:after {
    background-color: white;
    position: absolute;
    height: 2.5rem;
    content: '';
    left: ${({ checked }) => (checked ? '4px' : '10rem')};
    top: 4px;
    width: 9.75rem;
    border-radius: 90px;
    transition: 0.3s;
  }
`
